import styled from 'styled-components';
import { IconMoreAndroid } from '@spotify-internal/encore-creator-web';
import { color, spacer } from '@spotify-internal/encore-foundation';

export const IconMore = styled(IconMoreAndroid).attrs({
  color: color.white,
  size: 24,
})`
  margin-right: ${spacer.spacer4};
`;
